export const THE_PLACE_TO_BE_ENABLED = true;

export const THE_PLACE_TO_BE_TITLE = "Côte d'Ivoire, The Place To Be";
export const THE_PLACE_TO_BE_HERO_IMAGE = "/images/ivoirexperience/the-place-to-be/hero.jpg";
